import React, { useState } from 'react';
import ExcelJS from 'exceljs';
import {
  formatPrice,
  LoadingGrid,
} from '../../../../../rbts/helpers';
import Select from 'react-select';
import { useReporteVentas } from '../hooks/CortesiasHook';
import { styleSelect, themeSelect } from '../../../../../rbts/assets/ts/_utils';
import { useObtenerDiasPorEvento } from '../../cortesias/hooks/CortesiasHook';
import { useObtenerTodasCajas } from '../../../treasury/box_delivery/hooks';

type Props = {};

const productos = [
  {
    id: 1,
    value: 'Brazalete',
    label: 'Brazalete',
  },
  {
    id: 2,
    value: 'TicketCash',
    label: 'TicketCash',
  },
];

const Vista: React.FC<Props> = ({}) => {
  const [diasSeleccionados, setDiasSeleccionados] = useState<any[]>([]);
  const [prodSeleccionado, setProdSeleccionado] = useState<any | null>([]);
  const [idsDia, setIdsDia] = useState<number[]>([]);
  const [idCaja, setIdCaja] = useState<number>(0);
  const [nombreProducto, setNombreProducto] = useState<string>('');
  const [reloadInfo] = useState<number>(Math.random() * 40);
  const { list, ingresos, loadingRequest } = useReporteVentas(
    reloadInfo,
    idsDia,
    idCaja,
    nombreProducto
  );
  const { list: listadosDeDias, loadingRequest: cargandoDias } =
    useObtenerDiasPorEvento(reloadInfo);

  const [selectedOptionPOS, setSelectedOptionPOS] = useState<any | null>(null);
  const [reloadPOS, setReloadPOS] = useState(Math.random() * 40);
  const { catalog: POS, loadingRequest: loadingPOS } = useObtenerTodasCajas(
    reloadPOS,
    false
  );


  const grouped = list.reduce((acc: Record<string, { items: typeof list; subtotal: number }>, item) => {
    if (!acc[item.producto]) acc[item.producto] = { items: [], subtotal: 0 };
    acc[item.producto].items.push(item);
    acc[item.producto].subtotal += Number(item.costo_total);
    return acc;
  }, {});
  const groups = Object.entries(grouped);

  // DESCARGA EXCEL

  const [loadingDownload, setLoadingDownload] = React.useState(false);
  const columnsExcel: any = ['Producto', 'Tipo', 'Cantidad', 'Costo Total'];
  const handleDownloadExcel = async () => {
    setLoadingDownload(true);
    try {
      await exportTableToExcel(list, columnsExcel, `reporte_ventas.xlsx`);
    } catch (error) {
      console.error('Error downloading Excel:', error);
    } finally {
      setLoadingDownload(false);
    }
  };

  const exportTableToExcel = async (
    data: any[],
    columns: string[],
    filename = 'tabla.xlsx'
  ) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(`Ventas`);

    if (idsDia.length > 0) {
      worksheet.addRow([`Días Administrativos:`, diasSeleccionados.map((d: any) => d.label).join(', ')]);
    }
    if (idCaja > 0) {
      worksheet.addRow([`Caja:`, selectedOptionPOS.label]);
    }
    if (nombreProducto) {
      worksheet.addRow([`Producto:`, nombreProducto]);
    }

    if (idsDia.length > 0 || idCaja > 0 || nombreProducto) {
      worksheet.addRow([]);
      worksheet.addRow([]);
    }

    const headerRow = worksheet.addRow(['Producto', 'Tipo', 'Cantidad', 'Costo Total']);
    headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF8C24' } };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.columns = [
      { width: 30 },
      { width: 20 },
      { width: 15 },
      { width: 25 },
    ];

    data.forEach((item) => {
      const producto = item.producto;
      const efectivo = item.efectivo ? 'Efectivo' : 'Tarjeta';
      const cantidad = Number(item.cantidad);
      const costo_total = Number(item.costo_total);
      worksheet.addRow([producto, efectivo, cantidad, costo_total]);
    });

    worksheet.addRow([]);
    worksheet.addRow([]);

    const totalEfectivoRow = worksheet.addRow([
      '',
      '',
      'Total Efectivo',
      ingresos.ingreso_efectivo ? ingresos.ingreso_efectivo : 0,
    ]);
    totalEfectivoRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    totalEfectivoRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1A1A1A' } };

    const totalTarjetaRow = worksheet.addRow([
      '',
      '',
      'Total Tarjeta',
      ingresos.ingreso_tarjeta ? ingresos.ingreso_tarjeta : 0,
    ]);
    totalTarjetaRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    totalTarjetaRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1A1A1A' } };

    const totalGeneralRow = worksheet.addRow([
      '',
      '',
      'Total General',
      (ingresos.ingreso_efectivo ? ingresos.ingreso_efectivo : 0) +
        (ingresos.ingreso_tarjeta ? ingresos.ingreso_tarjeta : 0),
    ]);
    totalGeneralRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    totalGeneralRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF8C24' } };

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleDiasOnChange = (opts: any) => {
    const selected = opts ?? [];
    setDiasSeleccionados(selected);
    setIdsDia(selected.map((d: any) => d.value as number));
  };

  const changePOS = (selectedOption: any) => {
    if (selectedOption) {
      const { value } = selectedOption;
      setSelectedOptionPOS(selectedOption);
      setIdCaja(value);
    } else {
      setSelectedOptionPOS(null);
      setIdCaja(0);
    }
  };

  const handleProductOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setProdSeleccionado(selectedOption);
      setNombreProducto(selectedOption.value);
    } else {
      setProdSeleccionado(null);
      setNombreProducto('');
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className="card mb-6 mb-xl-9">
            <div className="card-header border-0 pt-5">
              <div className="card-title">
                <div className="w-300px pe-5 fs-7 text-white">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto text-white">
                      Días administrativos:{' '}
                    </label>
                  </div>
                  <Select
                    options={listadosDeDias}
                    value={diasSeleccionados}
                    styles={styleSelect}
                    theme={themeSelect}
                    classNamePrefix="tc-select"
                    placeholder={'Seleccione uno o varios días...'}
                    className="w-100"
                    isSearchable={true}
                    isMulti
                    closeMenuOnSelect={false}
                    noOptionsMessage={() => {
                      return <span>{'No se encontraron registros'}</span>;
                    }}
                    onChange={handleDiasOnChange}
                    isLoading={cargandoDias}
                    isClearable
                  />
                </div>
                <div className="w-300px pe-5 fs-7 text-white">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto text-white">Caja: </label>
                  </div>
                  <Select
                    options={POS}
                    value={selectedOptionPOS}
                    styles={styleSelect}
                    theme={themeSelect}
                    classNamePrefix="tc-select"
                    placeholder={'Seleccione'}
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return <span>{'No se encontraron registros'}</span>;
                    }}
                    onChange={changePOS}
                    isLoading={loadingPOS}
                    isClearable
                    backspaceRemovesValue
                  />
                </div>
                <div className="w-300px pe-5 fs-7 text-white">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto text-white">Producto: </label>
                  </div>
                  <Select
                    options={productos}
                    value={prodSeleccionado}
                    styles={styleSelect}
                    theme={themeSelect}
                    classNamePrefix="tc-select"
                    placeholder={'Seleccione'}
                    className="w-100"
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return <span>{'No se encontraron registros'}</span>;
                    }}
                    onChange={handleProductOnChange}
                    isClearable
                    backspaceRemovesValue
                  />
                </div>
              </div>
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3">
                  {list.length > 0 && (
                    <button
                      className="btn btn-sm btn-light-success"
                      disabled={loadingDownload}
                      onClick={() => handleDownloadExcel()}
                    >
                      {loadingDownload ? (
                        <span
                          className="indicator-progress"
                          style={{ display: 'block' }}
                        >
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          {/* <KTSVG
                            path="/media/icons/duotune/files/fil030.svg"
                            className="svg-icon-5 svg-icon-gray-500 me-3"
                          /> */}
                          Descargar
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body pt-3">
              {loadingRequest ? (
                <LoadingGrid text="Cargando..." />
              ) : groups.length === 0 ? (
                <div className="text-center text-muted py-8 fs-6">
                  No se encontraron ventas registradas.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-rounded border gy-4 gs-7">
                    <thead>
                      <tr className="fw-bolder fs-7 text-gray-800 border-bottom border-gray-200">
                        <th>Tipo</th>
                        <th className="text-center">Cantidad</th>
                        <th className="text-end">Costo Total</th>
                      </tr>
                    </thead>
                    {groups.map(([producto, group]) => (
                      <tbody
                        key={producto}
                        style={{ outline: '1px solid rgba(255, 140, 36, 0.25)', outlineOffset: '-1px' }}
                      >
                        <tr className="tc-report-group-header">
                          <td colSpan={3} className="fw-bolder fs-7 ps-3 py-2">
                            {producto}
                          </td>
                        </tr>
                        {group.items.map((item, idx) => (
                          <tr key={idx} className="align-middle">
                            <td className="fs-7">
                              <span
                                className={`badge ${
                                  item.efectivo
                                    ? 'badge-light-warning'
                                    : 'badge-light-primary'
                                }`}
                              >
                                {item.efectivo ? 'Efectivo' : 'Tarjeta'}
                              </span>
                            </td>
                            <td className="text-center fs-7">{item.cantidad}</td>
                            <td className="text-end fs-7 fw-semibold">
                              {formatPrice(item.costo_total ?? 0, 'es-MX', 'MXN', 2, 2)}
                            </td>
                          </tr>
                        ))}
                        <tr className="tc-report-subtotal">
                          <td colSpan={2} className="text-end fs-7 fw-bolder tc-report-subtotal-label">
                            Subtotal:
                          </td>
                          <td className="text-end fs-7 fw-bolder tc-report-subtotal-value">
                            {formatPrice(group.subtotal, 'es-MX', 'MXN', 2, 2)}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3} style={{ height: '10px', padding: 0 }} />
                        </tr>
                      </tbody>
                    ))}
                  </table>

                  <div className="d-flex justify-content-end mt-4">
                    <div
                      className="rounded px-6 py-3 d-flex gap-10"
                      style={{
                        backgroundColor: 'rgba(255, 140, 36, 0.12)',
                        border: '1px solid rgba(255, 140, 36, 0.3)',
                      }}
                    >
                      <div className="text-center">
                        <div className="fw-bold fs-8 text-uppercase mb-1" style={{ color: 'var(--tc-text-muted)' }}>Total Efectivo</div>
                        <div className="fw-bolder fs-6" style={{ color: 'var(--tc-primary)' }}>
                          {formatPrice(ingresos.ingreso_efectivo ?? 0, 'es-MX', 'MXN', 2, 2)}
                        </div>
                      </div>
                      <div className="text-center">
                        <div className="fw-bold fs-8 text-uppercase mb-1" style={{ color: 'var(--tc-text-muted)' }}>Total Tarjeta</div>
                        <div className="fw-bolder fs-6" style={{ color: 'var(--tc-primary)' }}>
                          {formatPrice(ingresos.ingreso_tarjeta ?? 0, 'es-MX', 'MXN', 2, 2)}
                        </div>
                      </div>
                      <div className="text-center">
                        <div className="fw-bold fs-8 text-uppercase mb-1" style={{ color: 'var(--tc-text-muted)' }}>Total General</div>
                        <div className="fw-bolder fs-5" style={{ color: 'var(--tc-primary)' }}>
                          {formatPrice(
                            (ingresos.ingreso_efectivo ?? 0) + (ingresos.ingreso_tarjeta ?? 0),
                            'es-MX',
                            'MXN',
                            2,
                            2
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Vista };
